import OtherConfigCommonFilter from './OtherConfigCommonFilter'
import { Box, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import { headerColumnDefs, otherCargoCol5Defs } from '../../BrnchMasterConstant'
import { Item } from '../../../../../common/snippets'
import { navigation3 } from '../../../../../common/helper'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
import LineinputV2 from '../../../../../common/lineinputV2'
import OtherConfigCommonBottom from './OtherConfigCommonBottom'
import { callAddFontRobotoBold } from '../../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { useEffect, useState } from 'react'

const MinFreightPerParcel = (props) => {
  const { tabInfo } = props
  const { resetFlag, setResetFlag, resetAllValueBrnhMaster, getBranchCargoData,
    brnhOtherCargoValue, setBrnchOtherCargoValue, onSave, confModal, setConfModal, isDisableBtn, setIsDisableBtn,
    handleBack, showBottom, setShowBottom, headerData, getPdfData, loginData } = tabInfo
  const [searchResult, setSearchResult] = useState(false)
  const [tableData, setTableData] = useState([])
  useEffect(() => {
    const fetchTableData = async () => {
      let data = await getPdfData()
      const formattedData = data.map((item, index) => ({
        ...item,
        SN: index + 1,
        isMinFreight: item?.IsMinFreightPerParcel === 1 ? 'Yes' : 'No',
        isMaxFreight: item?.IsMaxFreightPerParcel === 1 ? 'Yes' : 'No',
      }))
      setTableData(formattedData);
    };

    fetchTableData();
  }, [])
  const handleBrnhCargoValue = (value, field, prevValue) => {
    if (value != prevValue) {
      if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
        setConfModal((prev) => ({
          ...prev,
          branchOtherConfig: true
        }))
      }
      setBrnchOtherCargoValue((prev) => ({
        ...prev, [field]: value
      }))
    }
  }
  const handleBrnhCargoCheckValue = (value, field, prevValue, field1) => {
    if (value != prevValue) {
      if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
        setConfModal((prev) => ({
          ...prev,
          branchOtherConfig: true
        }))
      }
      if (value === 1) {
        setBrnchOtherCargoValue((prev) => ({
          ...prev, [field]: value
        }))
      } else if (value === 0) {
        setBrnchOtherCargoValue((prev) => ({
          ...prev, [field]: value,
          [field1]: 0
        }))
      }

    }
  }
  // const handleBrnhAmtDropDown = (value, field, field1, field2) => {
  //   if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
  //       setConfModal((prev) => ({
  //           ...prev,
  //           branchOtherConfig: true
  //       }))
  //   }
  //   setBrnchOtherCargoValue((prev) => ({
  //     ...prev, [field]: value, [field1]: 0, [field2]: 0
  //   }))
  // }
  const printClick = async (isSave = false) => {
    let pdfData = await getPdfData()
    pdfData = pdfData.map((item, index) => ({
      ...item,
      SN: index + 1,
      isMinFreight: item?.IsMinFreightPerParcel === 1 ? 'Yes' : 'No',
      isMaxFreight: item?.IsMaxFreightPerParcel === 1 ? 'Yes' : 'No',
    }))
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = headerColumnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfCols = otherCargoCol5Defs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }
    doc.setProperties({
      title: `Freight Per Parcel.pdf`,
      subject: 'Cargo Other Config',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Cargo Other Config',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: headerData,
      columnStyles: {
        0: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 16,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },

    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfCols,
      body: pdfData,
      columnStyles: {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 37, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 14,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo Other Config | Freight Per Parcel', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(`Print: Cargo Other Config | Freight Per Parcel`, data.settings.margin.left, 140)
        doc.text(`Branch: ${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 140, "right")
        doc.text(`Date & Time: ${moment(new Date()).format('DD-MMM-YYYY, ddd, HH:mm')} `, data.settings.margin.left, 160)
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      }
    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      const pdfData = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfData);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'Cargo Config-Freight Per Parcel.pdf';
      link.click();
    } else {
      // Trigger download
      const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // Open the PDF in a new tab
      window.open(pdfUrl);
    }
  }
  const InsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          <>
            <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
              {index + 1}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchCode}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.CityName}
            </TableCell>

            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.StateName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.isMinFreight}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.MinFreightPerParcel}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.isMaxFreight}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.MaxFreightPerParcel}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  return (
    !searchResult ?
      <>
        <OtherConfigCommonFilter
          resetAllValueBrnhMaster={() => {
            resetAllValueBrnhMaster();
            setResetFlag(!resetFlag)
          }}
          getData={getBranchCargoData} nextId='MF-PP' setShowBottom={setShowBottom} />
        <Divider />
        {showBottom && <>
          <Grid container sx={{ padding: '6px 0px', gap: '0px', }}>
            <Grid item md={2.1} style={{ paddingLeft: '8px' }}>
              <Item style={{ paddingRight: '0px' }}>
                <FormControlLabel
                  value="end"
                  control={<Checkbox checked={brnhOtherCargoValue?.IsMinFreightPerParcel === 1} id='MF-PP' />}
                  onKeyDown={(e) => {
                    navigation3(e, brnhOtherCargoValue?.IsMinFreightPerParcel === 1 ? "max_freight_per_parcel" : 'Max_freight_parcel', 'cargo_max_lr', () => { })
                  }}
                  label={
                    <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                      Minimum Freight Parcel
                    </Typography>
                  }
                  onChange={(event) => {
                    handleBrnhCargoCheckValue(event.target.checked ? 1 : 0, 'IsMinFreightPerParcel', brnhOtherCargoValue?.IsMinFreightPerParcel, 'MinFreightPerParcel')
                  }}
                  labelPlacement="end"
                />
              </Item>
            </Grid>
            <Grid item md={1.9} style={{ paddingLeft: '0px' }}>
              <Item className={'input--wrapper btmSpaceNotRequired'} style={{ paddingLeft: '0px', paddingRight: '5px' }}>
                <LineinputV2
                  label={'Min. Freight Per Parcel'}
                  id='max_freight_per_parcel'
                  icon={'crossIcon'}
                  value={brnhOtherCargoValue?.MinFreightPerParcel}
                  disabled={brnhOtherCargoValue?.IsMinFreightPerParcel === 0}
                  maxLength={4}
                  onKeyDown={(e) => {
                    navigation3(e, "Max_freight_parcel", 'MF-PP', () => { })
                  }}
                  onBlur={(event) => {
                    handleBrnhCargoValue(event.target.value, 'MinFreightPerParcel', brnhOtherCargoValue?.MinFreightPerParcel)
                  }}
                  resetCallback={() => {
                    handleBrnhCargoValue(0, 'MinFreightPerParcel', '')
                  }}
                />
              </Item>
            </Grid>
            <Grid item md={2.1} style={{ paddingRight: '0px' }}>
              <Item style={{ paddingRight: '0px' }}>
                <FormControlLabel
                  value="end"
                  control={<Checkbox checked={brnhOtherCargoValue?.IsMaxFreightPerParcel === 1} id='Max_freight_parcel' />}
                  onKeyDown={(e) => {
                    navigation3(e, brnhOtherCargoValue?.IsMaxFreightPerParcel === 1 ? "Max_Freight_Per_Parcel" : 'gst', brnhOtherCargoValue?.IsMinFreightPerParcel === 1 ? 'max_freight_per_parcel' : 'Freight_per_parcel', () => { })
                  }}
                  label={
                    <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                      Maximum Freight Parcel
                    </Typography>
                  }
                  labelPlacement="end"
                  onChange={(event) => {
                    handleBrnhCargoCheckValue(event.target.checked ? 1 : 0, 'IsMaxFreightPerParcel', brnhOtherCargoValue?.IsMaxFreightPerParcel, 'MaxFreightPerParcel')
                  }}
                />
              </Item>
            </Grid>
            <Grid item md={1.9}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2
                  label={'Max. Freight Per Parcel'}
                  id='Max_Freight_Per_Parcel'
                  icon={'crossIcon'}
                  value={brnhOtherCargoValue?.MaxFreightPerParcel}
                  disabled={brnhOtherCargoValue?.IsMaxFreightPerParcel === 0}
                  maxLength={4}
                  onKeyDown={(e) => {
                    navigation3(e, "cancelBtn", 'Max_freight_parcel', () => { })
                  }}
                  onBlur={(event) => {
                    handleBrnhCargoValue(event.target.value, 'MaxFreightPerParcel', brnhOtherCargoValue?.MaxFreightPerParcel)
                  }}
                  resetCallback={() => {
                    handleBrnhCargoValue(0, 'MaxFreightPerParcel', '')
                  }}
                />
              </Item>
            </Grid>
          </Grid>
          <Divider />
          <OtherConfigCommonBottom onSave={onSave} handleBack={handleBack} printClick={printClick} setSearchResult={setSearchResult} fileName={'minFreightPerParcel'} />
        </>}
        <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
          {/* ---------------Table For Excel--------------- */}
          <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              {/* -------TableHeader--------- */}
              <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                <TableCell className="reportTD" colSpan={4}>
                  Report For: Minimum Freight Per Parcel
                </TableCell>
                <TableCell className="reportTD" colSpan={4}>
                  Company Name : _Maven Tech Services Pvt. Ltd.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {headerColumnDefs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={2}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
              {headerData?.map((item, i) => (
                <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.CompanyName}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.State}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.City}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.Branch}</span>
                  </TableCell>
                </TableRow>))}
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ fontSize: '16px', verticalAlign: 'top' }}>
                {otherCargoCol5Defs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={1}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={11}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContentForExcel item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </>
      :
      <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
        <object
          id="freightPerParcelOutput"
          type="application/pdf"
          width="100%"
          height="200"
          title="MTLPL -Cargo System - Cargo Config - Freight Per Parcel"
          aria-label="MTLPL -Cargo System - Cargo Config- Freight Per Parcel"
        ></object>
      </Box>
  )
}

export default MinFreightPerParcel
